var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNvdaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#76B900;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.2,343.1v195h-35.6l-84.9-122.8h-1.4v122.8H89.1v-195h36.2l84.2,122.7h1.7V343.1H252.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.8,343.1l47.1,148.2h1.8L408,343.1h45.7l-67.2,195h-53.1l-67.3-195H311.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M536.6,538.1h-69.1v-195h69.7c19.6,0,36.5,3.9,50.7,11.7c14.2,7.8,25.1,18.9,32.7,33.5 c7.6,14.5,11.5,31.9,11.5,52.2c0,20.3-3.8,37.8-11.5,52.4c-7.7,14.6-18.6,25.8-32.9,33.6C573.4,534.2,556.4,538.1,536.6,538.1z  M508.7,502.8h26.2c12.2,0,22.5-2.2,30.8-6.5c8.3-4.3,14.6-11.1,18.9-20.3c4.2-9.2,6.3-21,6.3-35.6c0-14.4-2.1-26.2-6.3-35.3 c-4.2-9.1-10.5-15.9-18.8-20.2c-8.3-4.3-18.6-6.5-30.8-6.5h-26.3V502.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M675.5,538.1h-44.2l67.3-195h53.1l67.2,195h-44.2L726,387.7h-1.5L675.5,538.1z M672.8,461.5h104.4v32.2H672.8 V461.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNvdaIcon);
export default __webpack_public_path__ + "static/media/nvda_icon.7bc328505bbd7b3f32372e1769d8f98b.svg";
export { ForwardRef as ReactComponent };